<template>
  <div class="pt-2.5 mb-3 lg:mb-8">
    <div>
      <nuxt-img
          width="120"
          height="120"
          format="webp"
        :src="
          siteURL +
            '/storage/images/about/' + album + '/thumbnail_cache/' + image"
        class="rounded-full w-32 h-32 m-auto border-4 border-grayLight object-cover"
        :alt="name"
      />
    </div>
    <div class="mt-2.5">
      <p class="mb-2.5 text-3xl uppercase font-semibold">{{ name }}</p>
      <p
        class="text-white mb-1.5 rounded inline-block px-5 "
        :class="color"
      >
        {{ title }}
      </p>
      <p>{{ address }}</p>
      <a :href="'tel:' + phone" class="block underline">{{ phone }}</a>
      <a :href="'mailto:' + email" class="block underline">{{ email }}</a>
    </div>
  </div>
</template>

<script setup>
import {useSiteURL} from "~/composables/state";
const siteURL = useSiteURL();

defineProps([
  "name",
  "title",
  "address",
  "phone",
  "email",
  "album",
  "image",
  "color",
]);
</script>

<!--
TODO: culoare bg title cu tailwind
-->
